import ApplicationController from "./application_controller";
/* This is the custom StimulusReflex controller for ProjectsReflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = [
    "subTasksTab",
    "timeLogTab",
    "subtaskTabSelector",
    "timeLogTabSelector",
    "numberOfTasks",
    "hasRefreshed",
    "projectId",
    "lastRefreshed",
    "logTimeEntryForm",
    "startstoplink",
    "currentTaskId",
    "currentTaskState",
  ];

  /* Reflex specific lifecycle methods.
   * Use methods similar to this example to handle lifecycle concerns for a specific Reflex method.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Example:
   *
   *   <a href="#" data-reflex="ProjectsReflex#example">Example</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "ProjectsReflex#example"
   *
   *   error - error message from the server
   */

  connect() {
    super.connect();

    /*
      try {
       if ((this.lastRefreshedTarget.value == null || this.lastRefreshedTarget.value == "") && this.numberOfTasksTarget.value == 0) {
	       this.autoRefresher = setInterval(() => {
              if (this.lastRefreshedTarget.value == null || this.lastRefreshedTarget.value == "") {
                this.stimulate();
              }
              else {
	              clearInterval(this.autoRefresher);
	              this.stimulate();
              }
             }, 5000)
       }
      }
      catch {
	      // do nothing.
      }
      */
    /*
       try {
           if (this.currentTaskIdTarget.value != null && this.currentTaskIdTarget.value != "") {
	          this.autoRefreshTask = setInterval(() => {
		       this.taskState = this.currentTaskStateTarget.value
               this.taskStatus(this.currentTaskIdTarget.value);
             }, 10000)
	       
	       }
       }
       catch {
	       // do nothing task id is not set!
       }
       */
  }

  disconnect() {
    clearInterval(this.autoRefresher);
    clearInterval(this.autoRefreshTask);
  }

  addingTask(event) {
    document.getElementById("addTaskForm").style.display = "none";
    document.getElementById("adding_task").style.display = "block";
    //document.getElementById("add_task_btn").innerHTML = "Please Wait Adding Task...";
    //document.getElementById("add_task_btn").disabled = true;
  }
  updatingTask(event) {
    document.getElementById("editTaskForm").style.display = "none";
    document.getElementById("updating_task").style.display = "block";
  }
  editTask(event) {
    event.preventDefault();
    document.getElementById("editTaskForm").style.display = "block";
    document.getElementById("updating_task").style.display = "none";
    document.getElementById("edit_task_name").focus();
  }
  cancelEditTask(event) {
    event.preventDefault();
    document.getElementById("editTaskForm").style.display = "none";
    document.getElementById("updating_task").style.display = "none";
  }

  addTask(event) {
    event.preventDefault();
    document.getElementById("addTaskForm").style.display = "block";
    document.getElementById("adding_task").style.display = "none";
    document.getElementById("add_task_name").focus();
  }
  addingSubTask(event) {
    document.getElementById("addSubTaskForm").style.display = "none";
    document.getElementById("adding_sub_task").style.display = "block";
    //document.getElementById("add_task_btn").innerHTML = "Please Wait Adding Task...";
    //document.getElementById("add_task_btn").disabled = true;
  }
  addSubTask(event) {
    event.preventDefault();
    document.getElementById("addSubTaskForm").style.display = "block";
    document.getElementById("adding_sub_task").style.display = "none";
    document.getElementById("add_sub_task_name").focus();
  }
  cancelAddSubTask(event) {
    event.preventDefault();
    document.getElementById("addSubTaskForm").style.display = "none";
  }
  cancelAddTask(event) {
    event.preventDefault();
    document.getElementById("addTaskForm").style.display = "none";
  }

  logTimeEntry(element) {
    this.logTimeEntryFormTarget.style.display = "block";
  }

  beforeEditTaskRate(element) {
    element.innerText = "Enabling Edit...";
  }

  saveTaskRate(element) {
    document.getElementById("update_rate").innerText = "Saving...";
    this.stimulate(
      "ProjectsReflex#saveTaskRate",
      document.getElementById("edit_task_rate").getAttribute("data-taskid"),
      document.getElementById("edit_task_rate").value
    );
  }

  beforeEditTaskEstimatedHours(element) {
    element.innerText = "Enabling Edit...";
  }

  saveTaskEstimatedHours(element) {
    document.getElementById("update_estimated_hours").innerText = "Saving...";
    this.stimulate(
      "ProjectsReflex#saveTaskEstimatedHours",
      document
        .getElementById("edit_estimated_hours")
        .getAttribute("data-taskid"),
      document.getElementById("edit_estimated_hours").value
    );
  }

  beforeSaveTimeLog(element, reflex) {
    element.innerText = "Saving...";
    //element.disabled = true;
  }

  beforeStopTimerFromDashboard(element, reflex) {
    element.innerText = "Stopping Timer...";
  }

  beforeCompleteTask(element, reflex) {
    element.blur();
    element.innerText = "Marking Task as Complete...";
  }
  beforeUnCompleteTask(element, reflex) {
    element.blur();
    element.innerText = "Marking Task as UnComplete...";
  }

  beforeRefresh(element, reflex) {
    element.innerText = "Updating...";
  }

  refreshSuccess(element, reflex) {
    element.innerText = "Updated Successfully.";
  }

  refreshError(element, reflex, error) {
    console.error("updateError", error);
    element.innerText = "Update Failed!";
  }

  afterSelecttask(element, reflex) {
    var task_id = element.getAttribute("data-taskid");
    var project_id = element.getAttribute("data-projectid");
    history.pushState(null, null, "/projects/" + project_id + "/" + task_id);
    window.scrollTo(0, 0);
  }

  afterClosetaskwindow(element, reflex) {
    var project_id = element.getAttribute("data-projectid");
    history.pushState(null, null, "/projects/" + project_id);
    window.scrollTo(0, 0);
  }

  editTimeLog() {
    Turbo.visit("/time_logs/" + this.data.get("timelogid") + "/edit");
  }

  openTask() {
    Turbo.visit(
      "/projects/" + this.data.get("projectid") + "/" + this.data.get("taskid")
    );
  }

  selectTab(event) {
    event.preventDefault();

    if (
      event.currentTarget.getAttribute("data-projects-selectedtab") ==
      "timelogs"
    ) {
      this.timeLogTabTarget.style.display = "block";
      this.subTasksTabTarget.style.display = "none";
      this.subtaskTabSelectorTarget.classList.remove("border-l");
      this.subtaskTabSelectorTarget.classList.remove("border-t");
      this.subtaskTabSelectorTarget.classList.remove("border-r");
      this.subtaskTabSelectorTarget.classList.remove("rounded-t");
      this.subtaskTabSelectorTarget.classList.remove("-mb-px");

      this.timeLogTabSelectorTarget.classList.add("border-l");
      this.timeLogTabSelectorTarget.classList.add("border-t");
      this.timeLogTabSelectorTarget.classList.add("border-r");
      this.timeLogTabSelectorTarget.classList.add("rounded-t");
      this.timeLogTabSelectorTarget.classList.add("-mb-px");
    } else {
      this.timeLogTabTarget.style.display = "none";
      this.subTasksTabTarget.style.display = "block";
      this.timeLogTabSelectorTarget.classList.remove("border-l");
      this.timeLogTabSelectorTarget.classList.remove("border-t");
      this.timeLogTabSelectorTarget.classList.remove("border-r");
      this.timeLogTabSelectorTarget.classList.remove("rounded-t");
      this.timeLogTabSelectorTarget.classList.remove("-mb-px");

      this.subtaskTabSelectorTarget.classList.add("border-l");
      this.subtaskTabSelectorTarget.classList.add("border-t");
      this.subtaskTabSelectorTarget.classList.add("border-r");
      this.subtaskTabSelectorTarget.classList.add("rounded-t");
      this.subtaskTabSelectorTarget.classList.add("-mb-px");
    }
  }

  taskStatus(taskid) {
    /*
	Rails.ajax({
	      type: 'GET',
	      url: "/projects/task_status/"+ taskid,
	      dataType: 'json',
	      success: (data) => {
		      
		    if (this.taskState != data.taskState) {
			    console.log("refresh needed");
	            Rails.ajax({
	              type: 'GET',
	              url: "/projects/task/"+ taskid,
	              dataType: 'json',
	              success: (data) => {
	                document.getElementById("task2").innerHTML = data.task;
	              }
	            });
            }
            
            this.taskState = data.taskState;
		    
		  }
	 });
	 */
  }
  startStopTimer(event) {
    event.preventDefault();

    this.startstoplinkTarget.disabled = true;
    if (this.data.get("timerrunning") == "false") {
      this.startstoplinkTarget.innerHTML =
        "<i class='far fa-stopwatch mr-2'></i> Starting Timer....";
    } else {
      this.startstoplinkTarget.innerHTML =
        "<i class='far fa-stopwatch mr-2'></i> Stopping Timer....";
    }

    Rails.ajax({
      type: "GET",
      url: "/projects/start_stop_timer/" + this.data.get("taskid"),
      dataType: "json",
      success: (data) => {
        //this.loadingProjectSelectorTarget.style.display = "none";
        //this.projectSelectorTarget.innerHTML = data.projectSelector
        //document.getElementById("task2").innerHTML = data.task;
        //this.projectSelectorTarget.style.display = "block";
      },
    });
  }

  startStopTimerFromClock(event) {
    Rails.ajax({
      type: "GET",
      url: "/projects/start_stop_timer/" + this.data.get("taskid"),
      dataType: "json",
      success: (data) => {
        //this.loadingProjectSelectorTarget.style.display = "none";
        //this.projectSelectorTarget.innerHTML = data.projectSelector
        //document.getElementById("task2").innerHTML = data.task;
        //this.projectSelectorTarget.style.display = "block";
      },
    });
  }

  startStopTimerFromTrelloClock(event) {
    event.preventDefault();
    Rails.ajax({
      type: "GET",
      url:
        "/trello/start_stop_timer/" +
        this.data.get("taskid") +
        "?token=" +
        this.data.get("token"),
      dataType: "json",
      success: (data) => {
        t.closePopup();
      },
    });
  }
}
